import React, { useState, useEffect } from 'react';
import { Table, Input } from 'antd';
import { useNavigate, Link } from 'react-router-dom';
import moment from "moment";
import ReactPaginate from 'react-paginate';
import { productsService } from "../../services/ProductsService";
import Menu from '../../components/Menu/Menu';
import '../Products/Products.scss'
import './SearchProduct.scss'
import MobileBottomMenu from '../../components/MobileBottomMenu/MobileBottomMenu';
import MobileMenu from "../../components/Menu/MobileMenu";
const { Search } = Input;
const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: 'Barcode',
        dataIndex: 'barcode', // Changed to match API response
        key: 'barcode',
    },
    {
        title: 'Internal number',
        dataIndex: 'internal_number',
        key: 'internal_number',
    },
    {
        title: 'Measurement Unit',
        dataIndex: 'measurement_unit',
        key: 'measurement_unit',
    },
    {
        title: 'Selling price',
        dataIndex: 'selling_price',
        key: 'selling_price',
    },
    {
        title: 'PA TVA',
        dataIndex: 'pa_tva',
        key: 'pa_tva',
    }
];

const SearchProduct = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [pagination, setPagination] = useState({});
    const [searchQuery, setSearchQuery] = useState('');
    const [products, setProducts] = useState([]);
    const [searchResults, setSearchResults] = useState([]); // Stores search suggestions

    const dataSource = products ? Object.keys(products).map((answer) => ({
        products,
        ...products[answer],
    })) : [];



    const handleSearch = (value) => {
        setSearchQuery(value);

        if (value.length > 0) {
            productsService.searchProduct(value, 1)
                .then(response => {
                    if (response.status === 401) {
                        navigate("/login");
                    } else {
                        setSearchResults(response.data.products);
                    }
                })
                .catch(error => {
                    if (error.response && error.response.status === 401) {
                        navigate("/login");
                    } else {
                        console.error('Error fetching search results:', error);
                    }
                });
        } else {
            setSearchResults([]); // Clear suggestions when input is empty
        }
    };
    return (
        <div className='standard products standard__container'>
            <div className='standard__mobile-header'>
                <img src='/images/logo.png' alt='logo' className='standard__only-mobile standard__mobile-logo' />
                <MobileMenu />

            </div>
            <Menu />
            <div className='standard__wrapper'>
                {/* <h2 className='products__title standard__only-mobile'>Products </h2> */}

                <div className='search__search-area'>
                    <Search
                        className="search__search-input"
                        placeholder="Search products..."
                        onChange={(e) => handleSearch(e.target.value)}
                        enterButton
                    />

                    {searchResults.length > 0 && (
                        <ul className="search__search-dropdown">
                            {searchResults.map((product) => {
                                const regex = new RegExp(`(${searchQuery})`, "gi");
                                const highlightedName = product.name.replace(regex, (match) => `<span class="search__highlight">${match}</span>`);

                                return (
                                    <div className='search__result'>
                                        <img src='/images/search.png' alt='search' />
                                        <li key={product.id}>
                                            <Link className='standard__link' to={`/product/${product.id}`} dangerouslySetInnerHTML={{ __html: highlightedName }} />
                                        </li>
                                    </div>

                                );
                            })}
                        </ul>
                    )}
                </div>

            </div>
            <MobileBottomMenu />
        </div>
    );
};

export default SearchProduct;
